import { useQuery } from '@tanstack/react-query'
import { useRef, useState } from 'react'
import API from '../services/api'
import { Partner } from '../services/API/Entities/partner'
import { User } from '../services/API/Entities/users'
import { Patient as Patients } from '../services/API/Entities/patient'
import { debounce } from 'lodash'

export const FILTER_QUERY_KEYS = {
    PATIENTS: 'patients',
    PARTNERS: 'partners',
    USERS: 'users',
    TYPES: 'types',
    OBJECTS: 'runObjects',
    STATUSES: 'statuses',
}

const formatOptions = (list) => {
    return list.map((option) => ({
        value: option['@id'],
        label: option.label || `${option.firstname} ${option.lastname}`,
        data: option,
    }))
}

export const useRegulationPopUpQueries = () => {
    const [searchTerm, setSearchTerm] = useState('')
    const debouncedSearchRef = useRef(
        debounce((search) => {
            setSearchTerm(search)
        }, 600)
    ).current

    const patientsQuery = useQuery({
        queryKey: [FILTER_QUERY_KEYS.PATIENTS, searchTerm],
        queryFn: async () => {
            return await Patients.fetchAllForDebounceSearch(searchTerm)
        },
        enabled: searchTerm.trim() !== '',
        keepPreviousData: true,
        retry: false,
    })

    // Partners Query
    const partnersQuery = useQuery({
        queryKey: [FILTER_QUERY_KEYS.PARTNERS],
        queryFn: async () => {
            const response = await Partner.fetchAll()
            return formatOptions(response)
        },
        retry: false,
    })

    // Users Query
    const usersQuery = useQuery({
        queryKey: [FILTER_QUERY_KEYS.USERS],
        queryFn: async () => {
            const response = await User.fetchAll()
            return formatOptions(response)
        },
        retry: false,
    })

    // Types Query
    const typesQuery = useQuery({
        queryKey: [FILTER_QUERY_KEYS.TYPES],
        queryFn: async () => {
            const response = await API.Types.list()
            const data = await response.json()
            return formatOptions(data['hydra:member'])
        },
        retry: false,
    })

    // Objects Query
    const objectsQuery = useQuery({
        queryKey: [FILTER_QUERY_KEYS.OBJECTS],
        queryFn: async () => {
            const response = await API.RunObject.list()
            const data = await response.json()
            return formatOptions(data['hydra:member'])
        },
        retry: false,
    })

    // Statuses Query
    const statusesQuery = useQuery({
        queryKey: [FILTER_QUERY_KEYS.STATUSES],
        queryFn: async () => {
            const response = await API.Status.list()
            const data = await response.json()
            return formatOptions(data['hydra:member'])
        },
        retry: false,
    })

    return {
        patientsQuery,
        partnersQuery,
        usersQuery,
        typesQuery,
        objectsQuery,
        statusesQuery,
        debouncedSearchRef,
        searchTerm,
    }
}
